export const DeviceConfig = {
    name: "",
    description: "",
    model: "",
    ships_id: 0,
    ships_name: "",
    sensors_id: 0,
    sensors_name: "",
    alerts_id: 0,
    alerts_name: "",
    default: false
}

export const DeviceConfigDetails = {
    id: 0,
    name: "",
    model: "",
    default: false,

    ships: {
        id: 0,
        name: "",
        model: "",
        interval_type: "",
        h_start: 0,
        num_pub: 0,
        min_measure: 0,
        num_measure: 0,
        min_measure_b: 0,
        panel: 0
    },
    sensors: {
        id: 0,
        name: "",
        model: "",
        has_levels: false,
        vacuum_mark: 0,
        filling_mark: 0,
        email_to_filler: false,
        email_on_emptying: false,
        power: 0
    },
    alerts: {
        id: 0,
        name: "",
        description: "",
        has_movement: false,
        has_not_send: false,
        has_battery: false,
        has_temperature: false,
        has_signal: false,
        has_out_range: false,
        force: 0,
        days: 0,
        level: 0,
        temperature: 0,
        signal: 0,
        range: 0,
    }
}